import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck, Zap, Lock, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
export function OfferSection() {
  return <Section className="pb-8" id="offer" data-id="element-123">
      <div className="max-w-3xl mx-auto text-center" data-id="element-124">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-125">
          Tu Inversión Hoy
        </h2>

        <div className="bg-brand-card border-2 border-brand-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,83,0.15)] relative overflow-hidden" data-id="element-126">
          {/* Background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-brand-gold/10 to-transparent pointer-events-none" data-id="element-127" />

          <div className="relative z-10" data-id="element-128">
            <div className="flex justify-center items-end gap-4 mb-6" data-id="element-129">
              <span className="text-3xl text-brand-muted line-through decoration-brand-danger decoration-2" data-id="element-130">
                $27.95
              </span>
              <span className="text-6xl md:text-8xl font-bold text-brand-lightGold leading-none" data-id="element-131">
                $9.95
              </span>
            </div>

            <p className="text-xl text-gray-300 mb-10 max-w-lg mx-auto" data-id="element-132">
              Este manual cuesta menos que lo que pagarías por una comida
              rápida. Y eso es porque quiero asegurarme de que solo{' '}
              <strong className="text-white" data-id="element-133">
                hombres serios y comprometidos consigo mismos
              </strong>{' '}
              apliquen este sistema.
            </p>

            <Button className="md:w-auto md:px-8 py-4 text-xl mb-6 group" data-id="element-134">
              <span className="flex flex-col items-center justify-center gap-1" data-id="element-135">
                <span className="text-lg md:text-xl leading-tight text-center" data-id="element-136">
                  DESBLOQUEAR EL
                  <br data-id="element-137" />
                  PROTOCOLO COMPLETO
                </span>
                <span className="text-xs font-normal opacity-80" data-id="element-138">
                  Por solo $9.95
                </span>
                <span className="text-[10px] font-normal opacity-60" data-id="element-139">
                  (Oferta única por tiempo limitado)
                </span>
              </span>
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-12" data-id="element-140">
              <span className="flex items-center gap-1" data-id="element-141">
                <Lock className="w-3.5 h-3.5" data-id="element-142" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-143">
                <Zap className="w-3.5 h-3.5" data-id="element-144" /> Acceso Inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-145">
                <Shield className="w-3.5 h-3.5" data-id="element-146" /> Garantía de 60 días
              </span>
            </div>

            {/* Guarantee Box */}
            <div className="bg-[#0a0a0f] border border-brand-gold/20 rounded-xl p-6 text-left flex flex-col sm:flex-row gap-6 items-center sm:items-start" data-id="element-147">
              <div className="flex-shrink-0" data-id="element-148">
                <ShieldCheck className="w-16 h-16 text-brand-gold" data-id="element-149" />
              </div>
              <div data-id="element-150">
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-151">
                  GARANTÍA DE HIERRO - 60 DÍAS
                </h4>
                <p className="text-gray-400" data-id="element-152">
                  O recuperas tu vida sexual, o te devuelvo hasta el último
                  centavo. Sin preguntas. Sin excusas. Tienes 60 días completos
                  para probar el sistema sin ningún riesgo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}